import { useContext, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import TableContext from './context';

const TableSearch = () => {
	const { search, setSearch } = useContext(TableContext);

	const inputRef = useRef();
	const intl = useIntl();

	useEffect(() => {
		document.getElementById('search').addEventListener('search', (e) => (e?.target?.value === '' ? resetSearch() : null), true);
		inputRef.current.value = search ?? '';
	}, [search]);

	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			setSearch(event.target.value);
		}
	};

	const resetSearch = () => {
		inputRef.current.value = '';
		setSearch();
	};

	return (
		<div className="input-group input-search">
			<input
				id="search"
				type="search"
				className="form-control p-2"
				data-role="tagsinput"
				placeholder={intl.formatMessage({ id: 'RESERVATIONS.LIST.TABLE_VALUES.SEARCH' })}
				ref={inputRef}
				onKeyDown={handleKeyPress}
			/>
		</div>
	);
};

export default TableSearch;
